import { Icon } from '@activebrands/core-web/libs/storyblok/storyblok';

export const transformPaymentIcons = (paymentIcons: Icon[]) => {
    return paymentIcons.map((item: Icon) => {
        return {
            iconUrl: item?.icon[0]?.filename,
        };
    });
};
